/**
 * Piezas para los estados de carga: formas «fantasma» (esqueletos) con la misma medida que el contenido
 * real, un giro chico para acciones en curso y el texto «Cargando…» para lectores de pantalla.
 *
 * Reglas (ver «Estados de carga» en docs/arquitectura/web.md):
 *  - El esqueleto aparece solo si la carga tarda (`useMostrarTrasRetardo`, ~300 ms): si los datos llegan
 *    antes, se pasa directo al contenido, sin parpadeo. Mientras tanto la forma ocupa su lugar invisible
 *    (clase `carga--espera` en el contenedor), así nada salta.
 *  - Son decorativos (`aria-hidden`): la zona que carga lleva `aria-busy` y un `TextoCargando`.
 *  - El brillo se apaga con `prefers-reduced-motion` (Esqueleto.css).
 */
import './Esqueleto.css';

export type FormaEsqueleto =
  'linea' | 'titulo' | 'chip' | 'avatar' | 'icono' | 'numero' | 'bloque' | 'miniatura';

/** Anchos fijos (en % del contenedor) para que las líneas no se vean todas iguales. */
export type AnchoEsqueleto = 30 | 40 | 50 | 60 | 70 | 80 | 90 | 100;

export function Esqueleto({
  forma = 'linea',
  ancho,
  className,
}: {
  forma?: FormaEsqueleto;
  ancho?: AnchoEsqueleto;
  className?: string;
}) {
  const clases = ['esq', `esq--${forma}`, ancho ? `esq--a${ancho}` : '', className ?? '']
    .filter(Boolean)
    .join(' ');
  return <span className={clases} aria-hidden="true" />;
}

/** Aviso solo para lectores de pantalla mientras una zona carga (la zona lleva `aria-busy`). */
export function TextoCargando({ children = 'Cargando…' }: { children?: string }) {
  return (
    <span className="solo-lectores" role="status">
      {children}
    </span>
  );
}

/** Giro chico para acciones en curso (guardar, crear, mover). Toma el color del texto. */
export function Giro({ className }: { className?: string }) {
  return <span className={`giro${className ? ` ${className}` : ''}`} aria-hidden="true" />;
}
